export default [
  {
    path: '/plans/utility/list',
    name: 'plans.utility.list',
    component: () => import('@/views/modules/plans/utility-plan/ListUtilityPlans'),
    meta: {
      module: 'plans.utility',
      pageTitle: 'List Utilities Plans',
      breadcrumb: [
        { text: 'List Utilities Plans', active: true, },
        { text: 'Create Plan', to: {name: 'plans.utility.create'} }
      ],
    }
  },


  {
    path: '/plans/utility/create',
    name: 'plans.utility.create',
    component: () => import('@/views/modules/plans/utility-plan/CreateUtilityPlan'),
    meta: {
      module: 'plans.utility',
      pageTitle: 'Create Utility Plan',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.utility.list'} },
        { text: 'Create Utility Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/utility/:id/edit',
    name: 'plans.utility.edit',
    component: () => import('@/views/modules/plans/utility-plan/EditUtilityPlan'),
    meta: {
      module: 'plans.utility',
      pageTitle: 'Edit Utility Plan',
      breadcrumb: [
        { text: 'List Utilities Plans', to: {name: 'plans.utility.list'} },
        { text: 'Create Utility Plan' , to: {name: 'plans.utility.create'}},
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
